import React from 'react';
import { GridRange, gridRangeError, gridRangePreview } from '../../services/StrategySystematicsService';
import { MonoCell, NumberCell, ParamNest, ParamRow } from './ParamSheet';

interface GridRangeRowsProps {
  label: string;
  hint: string;
  range: GridRange;
  onChange: (next: GridRange) => void;
}

/// One optimizer grid entered as start / end / step, with the expanded list shown above it.
export const GridRangeRows: React.FC<GridRangeRowsProps> = ({ label, hint, range, onChange }) => {
  const error = gridRangeError(range);
  return (
    <>
      <ParamRow label={label} hint={hint}>
        <MonoCell text={error ?? gridRangePreview(range)} error={error !== null} />
      </ParamRow>
      <ParamNest>
        <ParamRow label="Start">
          <NumberCell value={range.start} onChange={(start) => onChange({ ...range, start })} />
        </ParamRow>
        <ParamRow label="End">
          <NumberCell value={range.end} onChange={(end) => onChange({ ...range, end })} />
        </ParamRow>
        <ParamRow label="Step">
          <NumberCell value={range.step} onChange={(step) => onChange({ ...range, step })} />
        </ParamRow>
      </ParamNest>
    </>
  );
};
